
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as CoreIcon } from "../fontello/icons/svg/ic_core.svg"


const Core = ({ ...props }) => (
  <SvgIcon
    component={CoreIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Core
